export const getLocaleDefault = () => 'en-US';
